export default '/static/frontend/ReachDigital/12gobiking/dist/assets/giropay-c075e6dd.svg'